import { ReactNode, useCallback, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { siteConfig } from '../../config/siteConfig';
import { Locale, LOCALE_STORAGE_KEY, messages } from '../../i18n';
import { LocaleContext } from './LocaleContext';

function getInitialLocale(): Locale {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  if (stored === 'sv' || stored === 'en') {
    return stored;
  }
  return siteConfig.defaultLocale;
}

export function LocaleProvider({ children }: { children: ReactNode }) {
  const [locale, setLocaleState] = useState<Locale>(getInitialLocale);

  const setLocale = useCallback((newLocale: Locale) => {
    localStorage.setItem(LOCALE_STORAGE_KEY, newLocale);
    setLocaleState(newLocale);
  }, []);

  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      <IntlProvider locale={locale} messages={messages[locale]}>
        {children}
      </IntlProvider>
    </LocaleContext.Provider>
  );
}
